module.exports = "/_assets/images/theming/hex-characters/corval-hex-laptop-help.png";